import Blur   from "./Blur.js";

import global from "../../global.js";

// const log = global.log.getLogger("f_mtac.voronoi.isopleth");

const Isopleth = (centers, width, height, scale) => {
    const w = Math.round(width * scale);
    const h = Math.round(height * scale);
    const x = global.d3.scaleLinear([0, width], [0, w]);
    const y = x; // Use scaleLinear([0, height], [0, h]); to change the aspect ratio (usually we wouldn't want that)

    // log.error({centers, width, height, scale});

    const rescale = (contour) => {
        for (const polygon of contour.coordinates) {
            for (const ring of polygon) {
                for (const pt of ring) {
                    pt[0] = x.invert(pt[0]);
                    pt[1] = y.invert(pt[1]);
                }
            }
        }
        return contour;
    };

    const nnmap = (delaunay, width, height) => {
        const site = new Uint16Array(width * height);
        const distance = new Float32Array(width * height);
        width |= 0;
        height |= 0;
        let n = 0;
        for (let i = 0; i < width; i++) {
            for (let j = 0; j < height; j++) {
                site[i + width * j] = n = delaunay.find(i, j);
                distance[i + width * j] = Math.hypot(
                    delaunay.points[2 * n] - i,
                    delaunay.points[2 * n + 1] - j
                );
            }
        }
        return { site, distance, width, height };
    };

    const delaunay = global.d3.Delaunay.from(centers.map(d => [x(d[0]), y(d[1])]));
    const nn = nnmap(delaunay, w, h);
    const bl = Blur().width(w);
    const ct = global.d3.contours().size([w, h]);

    // log.warn(delaunay);

    const datamap = (data, nn, borderradius, defaultValue) => {
        return Array.from(nn.site, (s, i) => {
            return nn.distance[i] < borderradius[s] * scale ? data[s] : defaultValue;
        });
    };

    const computecontours = (data, bandwidth, borderradius, defaultValue = 0) => {
        bl.radius(bandwidth * scale);
        return ct(bl(datamap(data, nn, borderradius, defaultValue))).map(rescale);
    };

    computecontours.thresholds = _ => _ ? (ct.thresholds(_), computecontours) : ct.thresholds();

    return computecontours;
};

export default Isopleth;
